import { render } from "./WalletButton.vue?vue&type=template&id=2973f337&scoped=true"
import script from "./WalletButton.vue?vue&type=script&lang=js"
export * from "./WalletButton.vue?vue&type=script&lang=js"

import "./WalletButton.vue?vue&type=style&index=0&id=2973f337&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2973f337"

export default script